const USER_PREFERENCES_STORAGE_KEY = 'cali.userPreferences';

export interface UserPreferences {
    locale?: string;
    lastSearchedAccountRegion?: string;
    lastSearchedPhoneRegion?: string;
}

export default class UserPreferencesStore {
    static read(): UserPreferences {
        const storedPreferences = window.localStorage.getItem(USER_PREFERENCES_STORAGE_KEY);

        if (!storedPreferences) {
            return {};
        }

        try {
            const parsedPreferences = JSON.parse(storedPreferences) as UserPreferences | null;

            if (parsedPreferences && typeof parsedPreferences === 'object' && !Array.isArray(parsedPreferences)) {
                return parsedPreferences;
            }
        } catch (error) {
            console.error('Failed to parse user preferences from localStorage', error);
        }

        return {};
    }

    static write(nextPreferences: Partial<UserPreferences>): void {
        const preferences = {
            ...UserPreferencesStore.read(),
            ...nextPreferences
        };

        window.localStorage.setItem(USER_PREFERENCES_STORAGE_KEY, JSON.stringify(preferences));
    }
}
